const HeadTitle = ({ content, align }) => {
  return (
    <div className="head-title" style={align ? { textAlign: align } : {}}>
      {content}
    </div>
  );
};

export default HeadTitle;
